import React from "react";
import './LeaderBoard.scss';
import * as constants from "../../../../const/constants";
import Header from "../../../../components/Header/Header";
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter";
import {lang, language} from "../../../../const/language";
import {Button, Col, Container, Row} from "reactstrap";
import 'vimond-replay/index.css';
import * as actionModalCreator from "../../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import {MDBDataTable} from 'mdbreact';
import * as tblConstants from '../../../../const/tableConst';
import NotFound from "../../../../components/NotFound/NotFound";

import * as commonFunc from "../../../../utils/commonFunc";
import * as paperService from '../../../../services/papers';

class ViewLeaderBoard extends React.Component {

    state = {

        lData: [],
        leaderBoard: []
    };

    componentDidMount() {
        this.viewLeaderBoard()
    }

    viewLeaderBoard = async (paper) => {
        if (this.state.lData.data.flowType) {
            const data = {
                "classId": this.state.lData.data.classId,
                "quizId": this.state.lData.data.quizId
            };
            console.log(data);
            await paperService.viewLeaderShipBoard(data)

                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.setState({
                            leaderBoard: res.body
                        })

                    } else {
                        commonFunc.notifyMessage(res.message);
                    }

                })
                .catch(error => {
                    console.log(error);
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);
        }else{

            const data = {
                "courseId": this.state.lData.data.courseId,
                "quizId": this.state.lData.data.quizId
            };
            console.log(data);
            await paperService.viewCourseLeaderShipBoard(data)

                .then(res => {
                    if (res.success) {
                        this.props.spinnerHandler(false);
                        this.setState({
                            leaderBoard: res.body
                        })

                    } else {
                        commonFunc.notifyMessage(res.message);
                    }

                })
                .catch(error => {
                    console.log(error);
                    this.props.spinnerHandler(false);
                    commonFunc.notifyMessage(error.message, error.status);
                });
            this.props.spinnerHandler(false);

        }
    };

    async UNSAFE_componentWillMount() {
        let state = this.props.location.state;
        if (state) {

            await this.setState({
                lData: state,

            })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_VIEW_PAPER_ROUTE}`);
        }

        console.log(this.state.lData)
    }


    render() {
        let {lData} = this.state;
        let result = [];

        this.state.leaderBoard.map((body, index) => {
            result.push({
                ...body,
                id: index + 1,

            })
        });

        console.log(lData);


        return (
            <div>
                <Header/>
                <main ref="main" className={"viewPaper"}>
                    <div className="backBtnHolder">
                        <button className={"home-btn"}
                                onClick={() => window.history.back()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <Row>
                        <Col lg="12">
                            <MDBDataTable
                                responsive
                                className={"table"}
                                striped
                                bordered
                                small
                                data={{
                                    columns: tblConstants.leaderBoardColums,
                                    rows: result,

                                }}
                            >
                            </MDBDataTable>
                        </Col>
                    </Row>

                </main>

                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});


const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewLeaderBoard));

/* Created By Janitha Prashad Katukenda
 jpk Created on Thu Dec 10 2020
Copyright (c) 2020 Ceyentra Technologies
EDULAB */
